var handlers = [];

function initBilling() {
  var section = document.querySelector(".mwai-billing-section");
  if (!section) return;

  cleanupBilling();

  var toggleBtns = section.querySelectorAll(".mwai-billing-toggle-btn");
  toggleBtns.forEach(function (btn) {
    var handler = function () {
      var cycle = btn.getAttribute("data-cycle");
      toggleBtns.forEach(function (b) {
        b.classList.remove("active");
      });
      btn.classList.add("active");
      updatePrices(section, cycle);
      updateCTAs(section, cycle);
    };
    btn.addEventListener("click", handler);
    handlers.push({ el: btn, handler: handler });
  });

  var featureBtns = section.querySelectorAll(".mwai-billing-features-toggle");
  featureBtns.forEach(function (btn) {
    var handler = function () {
      var card = btn.closest(".mwai-billing-plan-card");
      toggleExpand(btn, card.querySelector(".mwai-billing-plan-features"));
    };
    btn.addEventListener("click", handler);
    handlers.push({ el: btn, handler: handler });
  });

  var sectionBtns = section.querySelectorAll(".mwai-billing-section-header");
  sectionBtns.forEach(function (btn) {
    var handler = function () {
      toggleExpand(btn, btn.nextElementSibling);
    };
    btn.addEventListener("click", handler);
    handlers.push({ el: btn, handler: handler });
  });
}

function toggleExpand(trigger, target) {
  var expand = !trigger.classList.contains("expanded");
  trigger.classList.toggle("expanded", expand);
  target.classList.toggle("expanded", expand);
}

function updatePrices(section, cycle) {
  section
    .querySelectorAll("[data-yearly-price][data-monthly-price]")
    .forEach(function (el) {
      el.textContent =
        cycle === "yearly"
          ? el.getAttribute("data-yearly-price")
          : el.getAttribute("data-monthly-price");
    });

  var yearlyTotals = section.querySelectorAll(".mwai-billing-yearly-total");
  yearlyTotals.forEach(function (el) {
    el.style.display = cycle === "yearly" ? "" : "none";
  });
}

function updateCTAs(section, cycle) {
  var ctaLinks = section.querySelectorAll(".js-mwai-billing-cta");
  ctaLinks.forEach(function (link) {
    var url =
      cycle === "yearly"
        ? link.getAttribute("data-yearly-url")
        : link.getAttribute("data-monthly-url");
    if (url) link.setAttribute("href", url);
  });
}

function cleanupBilling() {
  handlers.forEach(function (h) {
    h.el.removeEventListener("click", h.handler);
  });
  handlers = [];
}

function resetBillingState() {
  var section = document.querySelector(".mwai-billing-section");
  if (!section) return;

  var toggleBtns = section.querySelectorAll(".mwai-billing-toggle-btn");
  toggleBtns.forEach(function (btn) {
    btn.classList.toggle(
      "active",
      btn.getAttribute("data-cycle") === "yearly"
    );
  });
  updatePrices(section, "yearly");
  updateCTAs(section, "yearly");

  section.querySelectorAll(".expanded").forEach(function (el) {
    el.classList.remove("expanded");
  });
}

document.addEventListener("turbo:load", initBilling);
document.addEventListener("turbo:before-cache", function () {
  resetBillingState();
  cleanupBilling();
});
